var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Head'),_c('div',{staticClass:"content-box"},[_c('el-scrollbar',{ref:"myScrollbar",attrs:{"wrap-class":"contentScrollbar"}},[_c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"move","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":"Home"}},[_c('router-view')],1)],1)],1)])],1),_c('Consult')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }